// libraries
import { useEffect, useState } from 'react'
import { useLocation } from 'react-router-dom'
import {
	AimOutlined,
	AlignLeftOutlined,
	AppstoreOutlined,
	CameraOutlined,
	PlusSquareOutlined,
	ProfileOutlined,
	ScheduleOutlined,
	TeamOutlined,
	UserAddOutlined,
	UsergroupAddOutlined,
	UserOutlined,
	WarningOutlined,
	StarFilled,
} from '@ant-design/icons'

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCompassDrafting, faCircle, faAd, faBellOn } from '@fortawesome/pro-duotone-svg-icons'
import { faTriangle } from '@fortawesome/pro-solid-svg-icons'

// resources
import { txt } from '../locales/i18n'

const OplevaltIcon = () => (
	<div>
		<FontAwesomeIcon size="xs" icon={faCircle} />
		<FontAwesomeIcon size="xs" style={{ transform: 'translateX(-50%)' }} icon={faTriangle} />
	</div>
)

export type RouteMatcher = {
	matcher: RegExp
	baseUrl: string
	name: string
	target: string
	icon: JSX.Element
	menuItem?: boolean
}

export const routeMatchers: RouteMatcher[] = [
	// users
	{
		matcher: /^\/users[/]*$/,
		baseUrl: '/users',
		name: txt('menu.users'),
		target: txt('global.overview'),
		icon: <UserOutlined />,
		menuItem: true,
	},
	{
		matcher: /^\/users\/images[/]*$/,
		baseUrl: '/users/images',
		name: txt('menu.profile images'),
		target: txt('global.overview'),
		icon: <CameraOutlined />,
		menuItem: true,
	},
	{
		matcher: /^\/users\/create[/]*$/,
		baseUrl: '/users',
		name: txt('menu.users'),
		target: txt('global.create'),
		icon: <UserOutlined />,
	},
	{
		matcher: /^\/users\/.*$/,
		baseUrl: '/users',
		name: txt('menu.users'),
		target: txt('global.edit'),
		icon: <UserOutlined />,
	},

	// posts
	{
		matcher: /^\/posts[/]*$/,
		baseUrl: '/posts',
		name: txt('menu.posts'),
		target: txt('global.overview'),
		icon: <ProfileOutlined />,
		menuItem: true,
	},
	{
		matcher: /^\/posts\/.*$/,
		baseUrl: '/posts',
		name: txt('menu.posts'),
		target: txt('global.edit'),
		icon: <ProfileOutlined />,
	},

	// unions
	{
		matcher: /^\/unions[/]*$/,
		baseUrl: '/unions',
		name: txt('menu.unions'),
		target: txt('global.overview'),
		icon: <UsergroupAddOutlined />,
		menuItem: true,
	},
	{
		matcher: /^\/unions\/create[/]*$/,
		baseUrl: '/unions',
		name: txt('menu.unions'),
		target: txt('global.create'),
		icon: <UsergroupAddOutlined />,
	},
	{
		matcher: /^\/unions\/.*$/,
		baseUrl: '/unions',
		name: txt('menu.unions'),
		target: txt('global.edit'),
		icon: <UsergroupAddOutlined />,
	},

	// activities
	{
		matcher: /^\/activities[/]*$/,
		baseUrl: '/activities',
		name: txt('menu.activities'),
		target: txt('global.overview'),
		icon: <ScheduleOutlined />,
		menuItem: true,
	},
	{
		matcher: /^\/activities\/create[/]*$/,
		baseUrl: '/activities',
		name: txt('menu.activities'),
		target: txt('global.create'),
		icon: <ScheduleOutlined />,
	},
	{
		matcher: /^\/activities\/.*$/,
		baseUrl: '/activities',
		name: txt('menu.activities'),
		target: txt('global.edit'),
		icon: <ScheduleOutlined />,
	},

	// groups
	{
		matcher: /^\/groups[/]*$/,
		baseUrl: '/groups',
		name: txt('menu.groups'),
		target: txt('global.overview'),
		icon: <TeamOutlined />,
		menuItem: true,
	},
	{
		matcher: /^\/groups\/create[/]*$/,
		baseUrl: '/groups',
		name: txt('menu.groups'),
		target: txt('global.create'),
		icon: <TeamOutlined />,
	},
	{
		matcher: /^\/groups\/.*$/,
		baseUrl: '/groups',
		name: txt('menu.groups'),
		target: txt('global.edit'),
		icon: <TeamOutlined />,
	},

	// christmas friends
	// {
	// 	matcher: /^\/christmas-friends[/]*$/,
	// 	baseUrl: '/christmas-friends',
	// 	name: txt('menu.christmas friends'),
	// 	target: txt('global.overview'),
	// 	icon: <StarOutlined />,
	// 	menuItem: true,
	// },
	// {
	// 	matcher: /^\/christmas-friends\/create[/]*$/,
	// 	baseUrl: '/christmas-friends',
	// 	name: txt('menu.christmas friends'),
	// 	target: txt('global.create'),
	// 	icon: <StarOutlined />,
	// },
	// {
	// 	matcher: /^\/christmas-friends\/\d+[/]*$/,
	// 	baseUrl: '/christmas-friends',
	// 	name: txt('menu.christmas friends'),
	// 	target: txt('global.edit'),
	// 	icon: <StarOutlined />,
	// },

	// stories
	// {
	// 	matcher: /^\/stories[/]*$/,
	// 	baseUrl: '/stories',
	// 	name: txt('menu.stories'),
	// 	target: txt('global.overview'),
	// 	icon: <ReadOutlined />,
	// 	menuItem: true,
	// },
	// {
	// 	matcher: /^\/stories\/create[/]*$/,
	// 	baseUrl: '/stories',
	// 	name: txt('menu.stories'),
	// 	target: txt('global.create'),
	// 	icon: <ReadOutlined />,
	// },
	// {
	// 	matcher: /^\/stories\/\d+[/]*$/,
	// 	baseUrl: '/stories',
	// 	name: txt('menu.stories'),
	// 	target: txt('global.edit'),
	// 	icon: <ReadOutlined />,
	// },

	// word track
	{
		matcher: /^\/word-track[/]*$/,
		baseUrl: '/word-track',
		name: txt('menu.word track'),
		target: txt('global.overview'),
		icon: <AimOutlined />,
		menuItem: true,
	},

	// statistics
	// {
	// 	matcher: /^\/statistics[/]*$/,
	// 	baseUrl: '/statistics',
	// 	name: txt('menu.statistics'),
	// 	target: txt('global.overview'),
	// 	icon: <PieChartOutlined />,
	// 	menuItem: true,
	// },

	// subjects
	{
		matcher: /^\/subjects[/]*$/,
		baseUrl: '/subjects',
		name: txt('menu.subjects'),
		target: txt('global.overview'),
		icon: <AlignLeftOutlined />,
		menuItem: true,
	},
	{
		matcher: /^\/subjects\/create[/]*$/,
		baseUrl: '/subjects',
		name: txt('menu.subjects'),
		target: txt('global.create'),
		icon: <AlignLeftOutlined />,
	},
	{
		matcher: /^\/subjects\/.*$/,
		baseUrl: '/subjects',
		name: txt('menu.subjects'),
		target: txt('global.edit'),
		icon: <AlignLeftOutlined />,
	},

	// reports
	{
		matcher: /^\/reports[/]*$/,
		baseUrl: '/reports',
		name: txt('menu.reports'),
		target: txt('global.overview'),
		icon: <WarningOutlined />,
		menuItem: true,
	},

	// red cross
	{
		matcher: /^\/red-cross[/]*$/,
		baseUrl: '/red-cross',
		name: txt('menu.red cross'),
		target: txt('global.overview'),
		icon: <PlusSquareOutlined />,
		menuItem: true,
	},

	// add user
	{
		matcher: /^\/adduser[/]*$/,
		baseUrl: '/adduser',
		name: txt('menu.create user'),
		target: txt('global.create'),
		icon: <UserAddOutlined />,
		menuItem: true,
	},

	// cms
	{
		matcher: /^\/cms[/]*$/,
		baseUrl: '/cms',
		name: txt('menu.cms'),
		target: txt('global.overview'),
		icon: <FontAwesomeIcon icon={faCompassDrafting} />,
		menuItem: true,
	},

	// cms
	{
		matcher: /^\/cms\/\w+$/,
		baseUrl: '/cms',
		name: txt('menu.cms'),
		target: txt('global.overview'),
		icon: <FontAwesomeIcon icon={faCompassDrafting} />,
	},

	// cms
	{
		matcher: /^\/cms\/\w+\/create[/]*$/,
		baseUrl: '/cms',
		name: txt('menu.cms'),
		target: txt('global.create'),
		icon: <FontAwesomeIcon icon={faCompassDrafting} />,
	},

	// cms
	{
		matcher: /^\/cms\/\w+\/.*$/,
		baseUrl: '/cms',
		name: txt('menu.cms'),
		target: txt('global.edit'),
		icon: <FontAwesomeIcon icon={faCompassDrafting} />,
	},

	// events
	{
		matcher: /^\/events[/]*$/,
		baseUrl: '/events',
		name: txt('menu.events'),
		target: txt('global.overview'),
		icon: <StarFilled />,
		menuItem: true,
	},

	{
		matcher: /^\/events\/create[/]*$/,
		baseUrl: '/events',
		name: txt('menu.events'),
		target: txt('global.create'),
		icon: <StarFilled />,
	},

	{
		matcher: /^\/events\/.*$/,
		baseUrl: '/events',
		name: txt('menu.events'),
		target: txt('global.edit'),
		icon: <StarFilled />,
	},

	// ads
	{
		matcher: /^\/advertisements[/]*$/,
		baseUrl: '/advertisements',
		name: txt('menu.advertisements'),
		target: txt('global.overview'),
		icon: <FontAwesomeIcon icon={faAd} />,
		menuItem: true,
	},

	{
		matcher: /^\/advertisements\/.*$/,
		baseUrl: '/advertisements',
		name: txt('menu.advertisements'),
		target: txt('global.create'),
		icon: <FontAwesomeIcon icon={faAd} />,
	},

	// dashboard
	{
		matcher: /^\/dashboards[/]*$/,
		baseUrl: '/dashboards',
		name: txt('menu.dashboard'),
		target: txt('global.overview'),
		icon: <AppstoreOutlined />,
		menuItem: true,
	},

	// oplevalt
	{
		matcher: /^\/oplevalt[/]*$/,
		baseUrl: '/oplevalt',
		name: 'oplev alt',
		target: txt('global.overview'),
		icon: <OplevaltIcon />,
		menuItem: true,
	},

	{
		matcher: /^\/oplevalt\/experiences[/]*$/,
		baseUrl: '/oplevalt',
		name: 'oplev alt',
		target: txt('oplevalt.experiences'),
		icon: <OplevaltIcon />,
	},

	{
		matcher: /^\/oplevalt\/experiences\/create[/]*$/,
		baseUrl: '/oplevalt',
		name: 'oplev alt',
		target: txt('oplevalt.experiences'),
		icon: <OplevaltIcon />,
	},

	{
		matcher: /^\/oplevalt\/experiences\/.*$/,
		baseUrl: '/oplevalt',
		name: 'oplev alt',
		target: txt('oplevalt.experience'),
		icon: <OplevaltIcon />,
	},

	{
		matcher: /^\/oplevalt\/cms[/]*$/,
		baseUrl: '/oplevalt',
		name: 'oplev alt',
		target: txt('menu.cms'),
		icon: <OplevaltIcon />,
	},

	{
		matcher: /^\/oplevalt\/cms\/\+[/]*$/,
		baseUrl: '/oplevalt/cms',
		name: 'oplev alt',
		target: txt('menu.cms'),
		icon: <OplevaltIcon />,
	},

	{
		matcher: /^\/oplevalt\/cms\/.*$/,
		baseUrl: '/oplevalt/cms',
		name: 'oplev alt',
		target: txt('menu.cms'),
		icon: <OplevaltIcon />,
	},

	// notifications
	{
		matcher: /^\/notifications[/]*$/,
		baseUrl: '/notifications',
		name: txt('menu.notifications'),
		target: txt('global.overview'),
		icon: <FontAwesomeIcon swapOpacity icon={faBellOn} />,
		menuItem: true,
	},

	{
		matcher: /^\/notifications\/\$*$/,
		baseUrl: '/notifications',
		name: txt('menu.notifications'),
		target: txt('global.create'),
		icon: <FontAwesomeIcon swapOpacity icon={faBellOn} />,
	},

	{
		matcher: /^\/notifications\/.*$/,
		baseUrl: '/notifications',
		name: txt('menu.notifications'),
		target: txt('global.edit'),
		icon: <FontAwesomeIcon swapOpacity icon={faBellOn} />,
	},
]

export function useRouteMatcher(): RouteMatcher | null {
	const [routeDetails, setRouteDetails] = useState<RouteMatcher | null>(null)
	const location = useLocation()

	useEffect(() => {
		const routeMatcher: RouteMatcher | undefined = routeMatchers.find((routeMatcher: RouteMatcher) => {
			return routeMatcher.matcher.test(location.pathname)
		})

		setRouteDetails(routeMatcher ?? null)
	}, [location])

	return routeDetails
}

/*

import * as antIcon from '@ant-design/icons';

// locales
import { txt } from '../../locales/i18n';

export type TMenuItem = {
	name: string;
	route: string;
	icon: JSX.Element;
};

export const menuItems: TMenuItem[] = [
	{
		name: txt('menu.users'),
		route: '/users',
		icon: <antIcon.UserOutlined />,
	},

	{
		name: txt('menu.posts'),
		route: '/posts',
		icon: <antIcon.ProfileOutlined />,
	},

	{
		name: txt('menu.unions'),
		route: '/unions',
		icon: <antIcon.UsergroupAddOutlined />,
	},

	{
		name: txt('menu.activities'),
		route: '/activities',
		icon: <antIcon.ScheduleOutlined />,
	},

	{
		name: txt('menu.word track'),
		route: '/word-track',
		icon: <antIcon.AimOutlined />,
	},

	{
		name: txt('menu.groups'),
		route: '/groups',
		icon: <antIcon.TeamOutlined />,
	},

	{
		name: txt('menu.stories'),
		route: '/stories',
		icon: <antIcon.ReadOutlined />,
	},

	{
		name: txt('menu.statistics'),
		route: '/statistics',
		icon: <antIcon.PieChartOutlined />,
	},

	{
		name: txt('menu.christmas friends'),
		route: '/christmas-friends',
		icon: <antIcon.StarOutlined />,
	},

	{
		name: txt('menu.profile images'),
		route: '/users/images',
		icon: <antIcon.CameraOutlined />,
	},

	{
		name: txt('menu.subjects'),
		route: '/subjects',
		icon: <antIcon.AlignLeftOutlined />,
	},

	{
		name: txt('menu.dashboard'),
		route: '/dashboards',
		icon: <antIcon.AppstoreOutlined />,
	},
];
*/
